<template>
    <el-form-item @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" :prop="getProp" :rules="rules" :label="labelParameter.labelName"  :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
        <el-input
          :value="value"
          @change="update"
          @input="update"
          :disabled=" component.properties.readonly"
          @focus="controlClick(component, index)"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin } from './mixins'

export default {
  name: 'rc-children-input',
  mixins: [ componentMixin, inputMixin, relFunMixin ],
  props: [ 'component', 'value', 'disabled', 'labelParameter', 'index', 'tableCtrlKey' ]
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-children-input.vue